import { Grid } from '@mui/material';
import { TextButton } from '../../../../../../ui/components/pure/text-button/text-button.component';
import { Colors } from '../../../../../../ui/theme/colors';
import { isBatchComplete, selectUploadableRowIDs } from '../../../../logic/courier-batch.utils';
import {
  BatchImportCouriersActionHandlers,
  BatchImportCouriersActionState
} from '../batch-import-couriers-action.hook';

export function CourierBatchActionsBar({
  state,
  handlers
}: {
  state: BatchImportCouriersActionState;
  handlers: BatchImportCouriersActionHandlers;
}) {
  const isBusy = state.isPreparing || state.isUploading;
  const isComplete = isBatchComplete(state.rows);
  const uploadCount = selectUploadableRowIDs(state.rows).length;
  const canUpload = uploadCount > 0;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px' }}>
      {!isComplete && (
        <span style={{ color: Colors.midGray, fontSize: '14px' }}>
          Selected {uploadCount} of {state.rows.length}
        </span>
      )}
      <Grid
        container
        spacing={1}
        sx={{
          justifyContent: 'flex-end'
        }}
      >
        {!state.hasUploaded && (
          <Grid>
            <TextButton color="secondary" variant="outlined" onClick={handlers.onCancel} disabled={isBusy}>
              Cancel
            </TextButton>
          </Grid>
        )}
        {!isComplete && (
          <>
            <Grid>
              <TextButton color="primary" variant="outlined" onClick={handlers.onValidate} disabled={isBusy}>
                Validate
              </TextButton>
            </Grid>
            <Grid>
              <TextButton
                color="primary"
                variant="contained"
                onClick={handlers.onUpload}
                disabled={isBusy || !canUpload}
                isLoading={state.isUploading}
              >
                Upload
              </TextButton>
            </Grid>
          </>
        )}
        {state.hasUploaded && (
          <Grid>
            <TextButton color="primary" variant="outlined" onClick={handlers.onDone} disabled={isBusy}>
              Done
            </TextButton>
          </Grid>
        )}
      </Grid>
    </div>
  );
}
